<div class="inner-router-wrapper">
    <div class="header-with-cta">
        <div class="dash-header">
            <div class="list">
                <div class="title-dialog">
                    <p>Select Start Date</p>
                    <mat-icon class="close" (click)="dialogRef.close()">close</mat-icon>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="title-dialog">
      <p>Add New Item</p>
      <mat-icon class="close" (click)="dialogRef.close()">close</mat-icon>
    </div> -->
    <div class="dialog-body" [formGroup]="itemForm">
      <div class="p-grid">
        <div class="p-col-6 input-group">
            <mat-form-field appearance="fill" class="input-group mb-2">
                <mat-label>Start Date</mat-label>
                <input matInput [matDatepicker]="picker" formControlName="ItemStartDate" [min]="minDate"
                [max]="maxStartDate" autocomplete="off" required>
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <div class="error-indicator" *ngIf="itemForm.controls.ItemStartDate.errors && (itemForm.controls.ItemStartDate.dirty || itemForm.controls.ItemStartDate.touched)">
                  <p *ngIf="itemForm.controls.ItemStartDate.errors.required">Start Date is required</p>
                </div>
              </mat-form-field>
          </div>
      </div>
    </div>
    <div>
        <div class="cta">
          <button class="back-btn" mat-raised-button (click)="dialogRef.close()">Cancel</button>
          <button mat-raised-button color="black" (click)="submit()" [disabled]="itemForm.invalid">Submit</button>
        </div>
      </div>
</div>